export const isTokenExpired = (dateTimeExpiration: number) => {
  let isExpired = false;

  if (!dateTimeExpiration || Date.now() >= dateTimeExpiration) {
    isExpired = true;
  }

  return isExpired;
};
